import React from 'react';
import { useSelector } from 'react-redux';
import { DebugTools } from '../../debug/store/debugToolTypes';
import { selectDebugToolProperty } from '../../debug/store/debugToolSelector';
import { selectIsMobileAppMode } from '../../platform/platformSelector';

import './MobileDebug.scss';

const MobileDebug = () => {
    const isMobileAppMode = useSelector(selectIsMobileAppMode);
    const simulateMobileKeyboard = useSelector(selectDebugToolProperty(DebugTools.MOBILE, 'simulateMobileKeyboard'));
    const simulateCapacitorSafeAreaBottom = useSelector(
        selectDebugToolProperty(DebugTools.MOBILE, 'simulateCapacitorSafeAreaBottom'),
    );

    return (
        <>
            {simulateMobileKeyboard && <div className="mobile-debug-container debug-mobile-keyboard"></div>}
            {isMobileAppMode && simulateCapacitorSafeAreaBottom && (
                <div className="mobile-debug-container debug-capacitor-safe-area-bottom"></div>
            )}
        </>
    );
};

export default MobileDebug;
